import { render, staticRenderFns } from "./tiscSkeleton.vue?vue&type=template&id=0039d0bc&scoped=true&"
import script from "./tiscSkeleton.vue?vue&type=script&lang=js&"
export * from "./tiscSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./tiscSkeleton.vue?vue&type=style&index=0&id=0039d0bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0039d0bc",
  null
  
)

export default component.exports